import { postRoute } from "../client"
import type { SocialVideoSubmissionDto } from "../../shared/engagementTypes"

export const submitSocialVideoRoute = postRoute<{ success: true; submission: SocialVideoSubmissionDto }>("/api/engagement/social-video")
